export default function Header() {
  return (
    <header className="logo">
      <a href="https://www.shecodes.io/" target="_blank" rel="noopener">
        <img src="/logo.png" alt="She Codes logo" width="150" />
      </a>
    </header>
  );
}
